function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PDF_Icon-poprawki",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_40",
  "data-name": "Rectangle 40",
  width: 10.011,
  height: 1.204,
  transform: "translate(4.807 5.172)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_41",
  "data-name": "Rectangle 41",
  width: 10.011,
  height: 1.204,
  transform: "translate(4.807 9.433)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M482.352,388.384h-4.167a.967.967,0,0,1-.967-.967V367.822a.967.967,0,0,1,.967-.967h13.54a.967.967,0,0,1,.967.967v13.427c.035-.008.069-.018.1-.025a2.37,2.37,0,0,1,.457-.044,2.626,2.626,0,0,1,1.514.488V367.433a2.708,2.708,0,0,0-2.708-2.708H477.85a2.708,2.708,0,0,0-2.708,2.708v20.374a2.708,2.708,0,0,0,2.708,2.708h6.8l-.243-.2A11.231,11.231,0,0,1,482.352,388.384Z",
  transform: "translate(-475.142 -364.725)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M516.666,423.332a13.944,13.944,0,0,0-2.006-6,1.862,1.862,0,0,0-1.838-.738,1.387,1.387,0,0,0-.522.215,1.651,1.651,0,0,0-1.76-.8,1.335,1.335,0,0,0-.726.457,1.767,1.767,0,0,0-1.542-.5,1.467,1.467,0,0,0-.579.238l-1.03-2.708a1.619,1.619,0,0,0-1.242-1.089,1.517,1.517,0,0,0-1.414.537,1.62,1.62,0,0,0-.2,1.639l2.529,6.654c-1.56-.662-2.777-1.037-3.362-.5a1.348,1.348,0,0,0-.5,1.05c.026.877.963,1.638,2.261,2.691a15.3,15.3,0,0,1,4.077,4.365.453.453,0,0,0,.56.209l6.925-2.632a.453.453,0,0,0,.292-.43,11.243,11.243,0,0,1,.038-1.317A11.889,11.889,0,0,0,516.666,423.332Zm-.944,1.27c-.022.264-.045.536-.044,1.087l-6.267,2.382a16.861,16.861,0,0,0-4.107-4.292c-.984-.8-1.913-1.552-1.926-2.015,0-.044,0-.161.2-.35.027-.014.27-.108,1.2.2.652.215,1.38.538,1.965.8l.21.093a.453.453,0,0,0,.606-.575l-2.912-7.662a.723.723,0,0,1,.06-.745.617.617,0,0,1,.567-.215.723.723,0,0,1,.54.517l1.361,3.581.008.02.856,2.253a.453.453,0,1,0,.847-.322l-.825-2.171a.428.428,0,0,1,.373-.322c.342-.063.837.119,1.111.841l.646,1.7a.453.453,0,0,0,.847-.322l-.622-1.638c-.018-.3.1-.5.331-.551a.818.818,0,0,1,.887.616l.151.4h0l.477,1.257a.453.453,0,0,0,.847-.321l-.424-1.118a.378.378,0,0,1,.308-.239.965.965,0,0,1,.9.345,13.067,13.067,0,0,1,1.859,5.513A11.034,11.034,0,0,1,515.722,424.6Z",
  transform: "translate(-495.036 -399.424)",
  fill: "#ccc"
}));

var SvgCorrectedFileIcon = function SvgCorrectedFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.632,
    height: 29.662,
    viewBox: "0 0 21.632 29.662",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorrectedFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/corrected_file_icon.59889501.svg";
export { ForwardRef as ReactComponent };